import React from "react";
import TimeDifference from "../../common/TimeDifference";
import { useNavigate } from "react-router-dom";
function ArticleItem({ 
    article,
    checkedItem,
    chindex,
    handleCheckboxChange }) {

  const navigate = useNavigate();   
  const handleCheckbox = (e) => {
    handleCheckboxChange(e, article,chindex);
  };
  const handlePrint = (id) => {
    // navigate to print-article on new tab
    window.open(`/print-article/${id}`, "_blank");

  }
  return (
    <>
      <div>
        <div className="pt-3">
          <div className="d-flex flex-md-row flex-column justify-content-md-between align-items-center">
            <div>
              <label
                htmlFor=""
                className="form-check form-check-custom form-check-inline form-check-solid"
              >
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked ={checkedItem}
                  onChange={handleCheckbox}
                />
                <span className="ps-2 fw-bold text-gray-900 fs-4 text-hover-primary">
                  {article && article.title}
                </span>
              </label>
            </div>
            <div className="btn-group">
              <div className="btn btn-sm btn-light-info" onClick={()=>handlePrint(article.id)}>
                <i className="bi bi-printer-fill"></i>
              </div>
            </div>
          </div>
          <div className="ps-7 me-5 ms-3">
            <span className="fw-semibold fs-6 mt-4 text-gray-600">
              {article && article.summary}
            </span>
            <div className="d-flex justify-content-end ">
              <span className="fw-semibold fs-6 text-gray-600 mt-1">
                {article && <TimeDifference dateString={article.modifiedAt} />}
                
              </span>
            </div>
          </div>
        </div>
        <div className="separator separator-dashed my-6"></div>
      </div>
    </>
  );
}

export default ArticleItem;
